import Vue from 'vue';
import Logo from '@/components/Logo.vue';
import ChannelVideoTag from './ChannelVideoTag.vue';
export default Vue.extend({
    name: 'ChannelNavbar',
    props: {
        channel: {
            type: Object,
            required: true,
        },
        filters: {
            type: Object,
        },
    },
    data() {
        return {};
    },
    computed: {
        cid() {
            return this.channel.id;
        },
        channelTags() {
            return this.channel?.channelTags ?? {};
        },
        renderSidePanel() {
            const { showSearch, showTagNavigation } = this?.channel.options;
            return showSearch || showTagNavigation;
        },
    },
    watch: {},
    methods: {
        removeTag() {
            this.$emit('remove-tag');
        },
    },
    components: {
        Logo,
        ChannelVideoTag,
    },
});
